import { render, staticRenderFns } from "./YourYearStep.vue?vue&type=template&id=24592442&lang=pug"
import script from "./YourYearStep.vue?vue&type=script&lang=js"
export * from "./YourYearStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports